export const CATEGORY_EXPERTS_STATE_UPDATE_INTERVAL_MS = 5000;
